import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import META from "./seoData.json";

const SITE_URL = (process.env.REACT_APP_PUBLIC_SITE_URL || "https://renatjanster.se").replace(/\/$/, "");

const FALLBACK = META["/"];

function upsertMeta(selector, attrs) {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    Object.entries(attrs.identifier).forEach(([k, v]) => tag.setAttribute(k, v));
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", attrs.content);
}

function upsertCanonical(href) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

export default function usePageMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = META[pathname] || FALLBACK;
    const canonical = SITE_URL + (pathname === "/" ? "/" : pathname);

    document.title = meta.title;

    upsertMeta('meta[name="description"]', {
      identifier: { name: "description" },
      content: meta.description,
    });
    upsertMeta('meta[property="og:title"]', {
      identifier: { property: "og:title" },
      content: meta.title,
    });
    upsertMeta('meta[property="og:description"]', {
      identifier: { property: "og:description" },
      content: meta.description,
    });
    upsertMeta('meta[property="og:url"]', {
      identifier: { property: "og:url" },
      content: canonical,
    });
    upsertMeta('meta[name="twitter:title"]', {
      identifier: { name: "twitter:title" },
      content: meta.title,
    });
    upsertMeta('meta[name="twitter:description"]', {
      identifier: { name: "twitter:description" },
      content: meta.description,
    });
    upsertCanonical(canonical);
  }, [pathname]);
}
